import type { Novidade } from './tipos';

/**
 * Fase 2, W23 (K10; decisão 14 do plano da fase 2): o funcionário ganha a ligação opcional com um fornecedor ou parceiro do
 * Cadastros. A imagem vem da prova `scripts/provas/w23-parceiro-tarefa.ts` (`CAPTURAR=1`, modo discreto ligado).
 */
export const novidadeFuncionarioParceiro: Novidade = {
  id: '2026-10-05-funcionario-parceiro',
  publicada_em: '2026-10-05',
  tipo: 'melhoria',
  modulo: 'pessoas',
  permissao: 'pessoas.editar',
  rota: '/pessoas/pessoas/funcionarios',
  textos: {
    pt: {
      titulo: 'Funcionário ligado a um fornecedor do Cadastros',
      resumo: 'Para o PJ ou para reembolso, o funcionário pode ter um fornecedor ligado, sem levar salário e RH para o Cadastros.',
      passos: [
        'Na ficha do funcionário, o cartão Fornecedor ou parceiro mostra a ligação com o Cadastros.',
        'Criar também como fornecedor cria a pessoa física com nome, CPF, e-mail e telefone. Se o CPF já existir, só liga.',
        'Ligar a um parceiro sugere o cadastro com o mesmo CPF e busca qualquer outro, como a empresa do PJ.',
        'Na ficha do parceiro, É funcionário leva de volta à ficha, para quem pode ver o Pessoas.',
      ],
    },
    en: {
      titulo: 'Employee linked to a supplier in Records',
      resumo: 'For a contractor (PJ) or reimbursements, the employee can have a linked supplier, without taking salary and HR data to Records.',
      passos: [
        'On the employee record, the Supplier or partner card shows the link with Records.',
        'Also create as supplier creates the individual with name, CPF, email and phone. If the CPF already exists, it only links.',
        'Link to a partner suggests the record with the same CPF and searches any other, such as the contractor company.',
        'On the partner record, Is an employee leads back to the employee, for those who can see People.',
      ],
    },
    es: {
      titulo: 'Empleado vinculado a un proveedor de Registros',
      resumo: 'Para el contratista (PJ) o reembolsos, el empleado puede tener un proveedor vinculado, sin llevar salario y RR. HH. a Registros.',
      passos: [
        'En la ficha del empleado, la tarjeta Proveedor o socio muestra el vínculo con Registros.',
        'Crear también como proveedor crea la persona física con nombre, CPF, correo y teléfono. Si el CPF ya existe, solo vincula.',
        'Vincular a un socio sugiere el registro con el mismo CPF y busca cualquier otro, como la empresa del contratista.',
        'En la ficha del socio, Es empleado lleva de vuelta a la ficha, para quien puede ver Personas.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-funcionario-parceiro/ficha.webp', null, null, null],
  treinamento: { curso: 'novidades' },
};
